export function cn(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ');
}

/**
 * Where a link to "the homepage" should point for a given language.
 *
 * The Dutch homepage is canonical at the site root, but every internal link
 * pointed at /nl/ - so the URL Google is asked to index had no internal links
 * at all, and every menu, logo and breadcrumb sent readers through a page that
 * only names another one.
 */
export function homeHref(locale: string): string {
  return locale === 'nl' ? '/' : `/${locale}/`;
}
